<template>
  <div id="menu">
    <div v-for="title in Object.keys(menuItems)" :key="title" class="menu-wrapper">
      <div class="title">{{ $t(`etc.menu.${title}`) }}</div>

      <template v-for="(menu, i) in menuItems[title]">
        <button
          v-if="!menu.onlyLogin && (!menu?.openDate || openMenu(menu?.openDate))"
          :key="i"
          class="d-flex align-items-center nav-main-link w-100"
          @click="menu.clickFunc(menu.route)"
        >
          <img class="icon" :src="`${$s3}/img/${menu.img}?${$ver}`" />
          <span class="ml-2">
            {{ $t(menu.title) }}
            <img v-if="menu.img === 'lotto'" class="mb-1" :src="`${$s3}/img/common/beta.svg?${$ver}`" />
          </span>
        </button>
      </template>
    </div>

    <template v-if="isLogin">
      <div class="split-line" />

      <Attendance :side-bar="sideBar" />
    </template>
    <div v-else style="padding-bottom: 20px" />

    <div v-if="isMobile" class="gap-fill" :style="{ height: innerHeight }" />

    <!-- <footer> -->
    <!--   <SetLanguage save white></SetLanguage> -->
    <!-- </footer> -->
    <Modal id="swap-mobile-menu" ref="swap-mobile-menu" />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import Attendance from '@/layouts/partials/Menus/Attendance';
import Modal from '@/views/Components/Modal';

export default {
  components: {
    Attendance,
    Modal,
  },
  props: {
    sideBar: {
      type: Boolean,
      default: false,
    },
    closeMenu: {
      type: Function,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      innerHeight: '0px',
      modal: null,
    };
  },
  computed: {
    ...mapState(['isPhone', 'isLogin', 'city', 'lang', 'isMobile']),
    menuItems() {
      const menuObj = {
        my: [
          {
            img: 'common/mobileSidebar/property.svg',
            clickFunc: this.goTo,
            route: this.isLogin ? 'Assets' : 'Login',
            // 내 자산
            title: 'property.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/mypage.webp',
            clickFunc: this.goTo,
            route: 'MyPage',
            // 마이페이지
            title: 'mypage.title',
            onlyLogin: !this.isLogin,
          },
        ],
        service: [
          {
            img: 'common/mobileSidebar/map.svg',
            clickFunc: this.goTo,
            route: 'Land',
            // 지도
            title: 'map.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/subscription.svg',
            clickFunc: this.goTo,
            route: 'Subscription information',
            // 청약정보
            title: 'subscription.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/community.svg',
            clickFunc: this.goTo,
            route: 'Community',
            // 오픈커뮤니티
            title: 'community.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/rank.svg',
            clickFunc: this.goTo,
            route: 'Rank',
            // 랭킹
            title: 'rank.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/event.svg',
            clickFunc: this.goTo,
            route: 'EventHome',
            // 이벤트
            title: 'event.title',
            onlyLogin: false,
            openDate: '2023-03-13',
          },
          {
            img: 'common/mobileSidebar/store.webp',
            clickFunc: this.goTo,
            route: 'Store',
            // 상점
            title: 'store.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/swap.webp',
            clickFunc: this.goTo,
            route: 'Swap',
            // 스왑페이지
            title: 'etc.swap.title',
            onlyLogin: false,
          },
        ],
        info: [
          {
            img: 'common/mobileSidebar/support.svg',
            clickFunc: this.openLink,
            route: this.$notice(this.lang),
            // 공지
            title: 'etc.announce.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/guide.svg',
            clickFunc: this.goTo,
            route: 'Guide',
            // 가이드
            title: 'guide.title',
            onlyLogin: false,
          },
          {
            img: 'common/mobileSidebar/alert.svg',
            clickFunc: this.goTo,
            route: 'Alert',
            // 알림
            title: 'noti.title',
            onlyLogin: !this.isLogin,
          },
          {
            img: 'common/mobileSidebar/mypage.webp',
            clickFunc: this.goTo,
            route: 'Login',
            // 로그인
            title: 'etc.login.title',
            onlyLogin: this.isLogin,
          },
          {
            img: 'common/mobileSidebar/logout.svg',
            clickFunc: this.logout,
            route: null,
            // 로그아웃
            title: 'etc.logout',
            onlyLogin: !this.isLogin,
          },
        ],
      };

      if (this.lang === 'ko') return menuObj;

      menuObj.service = menuObj.service.filter((menu) => menu.route !== 'Community');
      return menuObj;
    },
  },
  mounted() {
    this.getInnerHeight();
    this.modal = this.$refs?.['swap-mobile-menu'];
  },
  methods: {
    ...mapMutations(['sidebar']),
    ...mapActions({
      getLogout: 'logout',
    }),
    goTo(routeName) {
      if (this.$route.name === routeName) {
        this.$router.go(0);
      } else if (routeName === 'Land') {
        this.$router.push({ path: `/map`, query: { city: this.city } });
      } else if (routeName === 'Swap') {
        window.location.href = process.env.VUE_APP_SWAP_URL;
      } else {
        this.$router.push({ name: routeName });
      }

      this.sidebar({ mode: 'close' });
      this.closeMenu && this.closeMenu();
    },
    openLink(link) {
      this.closeMenu && this.closeMenu();
      window.open(link);
    },
    async logout() {
      await this.getLogout();
      this.$route.name !== 'Main' && this.$router.push({ name: 'Main' });
      this.$bvModal.show('logout');
    },
    openMenu(date) {
      if (!date) return false;
      else {
        const now = this.$DateTime.now();
        const openDate = this.$tl(date, this.lang);

        return now > openDate;
      }
    },
    getInnerHeight() {
      const menu = document.getElementById('menu');
      const menuChildren = menu?.children;
      if (!menuChildren) return;
      let sum = 0;

      for (let i = 0; i < menuChildren.length; i++) {
        sum += menuChildren[i].offsetHeight;
      }

      this.innerHeight = `calc(calc(var(--vh, 1vh) * 100) - 80px - ${sum}px)`;
    },
  },
};
</script>

<style lang="scss" scoped>
#menu {
  position: relative;
  border-collapse: collapse;
  background: #ffffff;
  width: 100%;
  min-width: 272px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(calc(var(--vh, 1vh) * 100) - 140px);

  &:not(.side-bar) {
    border-top: none;
    padding-top: 5px;
  }

  &.side-bar {
    overflow: unset;
    position: relative;
    min-height: 100%;
    border-radius: 0;

    footer {
      position: sticky;
      width: 100%;
      bottom: 0;
    }
  }

  .menu-wrapper {
    .title {
      padding-left: 18px;
      color: #333333;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      height: 35px;
      padding-top: 5px;
      line-height: 30px;
    }
    .nav-main-link {
      padding: 0;
      padding-left: 36px;
    }
  }

  .split-line {
    margin: 0 16px;
    margin-top: 6px;
    border: 0.5px solid #ededed;
  }

  button img.icon {
    width: 24px;
    height: 24px;
  }

  footer {
    position: sticky;
    bottom: 0;
    display: grid;
    place-items: center;
    align-content: center;
    background: #043158;
    height: 54px;

    ::v-deep select {
      color: white;
      font-size: 16px;

      option {
        color: #333333;
      }
    }
  }
}
</style>
